import Vue from 'vue'
import Router from 'vue-router'
import store from '../vuex/store.js'
// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import DashboardExecutivoMobile from '@/views/dashboard/DashboardExecutivoMobile'

import Colors from '@/views/theme/Colors'
import Typography from '@/views/theme/Typography'

import Charts from '@/views/Charts'
import Widgets from '@/views/Widgets'

// Views - Components
import Cards from '@/views/base/Cards'
import Forms from '@/views/base/Forms'
import Switches from '@/views/base/Switches'
import Tables from '@/views/base/Tables'
import Breadcrumbs from '@/views/base/Breadcrumbs'
import Carousels from '@/views/base/Carousels'
import Collapses from '@/views/base/Collapses'
import Jumbotrons from '@/views/base/Jumbotrons'
import ListGroups from '@/views/base/ListGroups'
import Navs from '@/views/base/Navs'
import Navbars from '@/views/base/Navbars'
import Paginations from '@/views/base/Paginations'
import Popovers from '@/views/base/Popovers'
import ProgressBars from '@/views/base/ProgressBars'
import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
import StandardButtons from '@/views/buttons/StandardButtons'
import ButtonGroups from '@/views/buttons/ButtonGroups'
import Dropdowns from '@/views/buttons/Dropdowns'
import SocialButtons from '@/views/buttons/SocialButtons'

// Views - Icons
import Flags from '@/views/icons/Flags'
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'

// Views - Notifications
import Alerts from '@/views/notifications/Alerts'
import Badges from '@/views/notifications/Badges'
import Modals from '@/views/notifications/Modals'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'
import Senha from '@/views/pages/Senha'

// Cadastros
import Clientes from '@/views/cadastros/clientes/Clientes'
import ClientesEdit from '@/views/cadastros/clientes/ClientesEdit'
import CfopListagem from '@/views/cadastros/cfop/CfopListagem'
import CfopCadastro from '@/views/cadastros/cfop/CfopCadastro'
import VendedorListagem from '@/views/cadastros/vendedor/VendedorListagem'
import VendedorCadastro from '@/views/cadastros/vendedor/VendedorCadastro'
import ProdutosListagem from '@/views/cadastros/produtos/ProdutosListagem'
import ProdutosCadastro from '@/views/cadastros/produtos/ProdutosCadastro'
import TipoMovimentacaoListagem from '@/views/cadastros/tipomovimentacao/TipoMovimentacaoListagem'
import TipoMovimentacaoCadastro from '@/views/cadastros/tipomovimentacao/TipoMovimentacaoCadastro'

import FuncionarioListagem from '@/views/cadastros/funcionario/FuncionarioListagem'
import TributacaoIcmsListagem from '@/views/cadastros/tributacao-icms/TributacaoIcmsListagem'
import TributacaoIcmsCadastro from '@/views/cadastros/tributacao-icms/TributacaoIcmsCadastro'
import FuncionarioCadastro from '@/views/cadastros/funcionario/FuncionarioCadastro'


import AlmoxarifadoListagem from '@/views/almoxarifado/requisicao/RequisicaoListagem.vue'      // /almoxarifado/requisacao/index
import AlmoxarifadoAtendimento from '@/views/almoxarifado/requisicao/RequisicaoAtendimento.vue'  // /almoxarifado/requisacao/atendimento/:id
import AlmoxarifadoInventarioListagem from '@/views/almoxarifado/inventario/InventarioListagem.vue'       // /almoxarifado/inventario/index
import AlmoxarifadoInventarioCadastro from '@/views/almoxarifado/inventario/InventarioCadastro.vue'       // /almoxarifado/inventario/add|edit:id
import MinhasRequisicoesListagem from '@/views/almoxarifado/minhas/MinhasRequisicoesListagem.vue' // /almoxarifado/requisacao/minhasrequisicoes/index
import MinhasReqisicoesCadastro from '@/views/almoxarifado/minhas/MinhasRequisicoesCadastro.vue' // /almoxarifado/requisacao/minhasrequisicoes/add|edit/:id
import BensListagem from '@/views/almoxarifado/bens/BensListagem.vue'                   // /almoxarifado/bens/index
import BensCadastro from '@/views/almoxarifado/bens/BensCadastro.vue'                   // /almoxarifado/bens/add|edit/:id
import DepartamentoListagem from '@/views/almoxarifado/departamento/DepartamentoListagem.vue'   // /almoxarifado/departamento/index
import DepartamentoCadastro from '@/views/almoxarifado/departamento/DepartamentoCadastro.vue'   // /almoxarifado/departamento/add|edit/:id
import CentroCustoListagem from '@/views/centrocusto/CentroCustoListagem.vue'
import CentroCustoCadastro from '@/views/centrocusto/CentroCustoCadastro.vue'
import HistoricoListagem from '@/views/cadastros/historico/HistoricoListagem.vue'
import HistoricoCadastro from '@/views/cadastros/historico/HistoricoCadastro.vue'
import GrupoApagarListagem from '@/views/cadastros/grupo/GrupoApagarListagem.vue'
import GrupoApagarCadastro from '@/views/cadastros/grupo/GrupoApagarCadastro.vue'
import GrupoAreceberListagem from '@/views/cadastros/grupo/GrupoAreceberListagem.vue'
import GrupoAreceberCadastro from '@/views/cadastros/grupo/GrupoAreceberCadastro.vue'
import GrupoProdutoListagem from '@/views/cadastros/grupo-produto/GrupoProdutoListagem.vue'
import GrupoProdutoCadastro from '@/views/cadastros/grupo-produto/GrupoProdutoCadastro.vue'
import SubgrupoProdutoListagem from '@/views/cadastros/subgrupo-produto/SubgrupoProdutoListagem.vue'
import SubgrupoProdutoCadastro from '@/views/cadastros/subgrupo-produto/SubgrupoProdutoCadastro.vue'
import TipoBeneficiamentoListagem from '@/views/cadastros/tipo-beneficiamento/TipoBeneficiamentoListagem.vue'
import TipoBeneficiamentoCadastro from '@/views/cadastros/tipo-beneficiamento/TipoBeneficiamentoCadastro.vue'
import TipoProdutoListagem from '@/views/cadastros/tipo-produto/TipoProdutoListagem.vue'
import TipoProdutoCadastro from '@/views/cadastros/tipo-produto/TipoProdutoCadastro.vue'
import TransportadoraListagem from '@/views/cadastros/transportadora/TransportadoraListagem.vue'
import TransportadoraCadastro from '@/views/cadastros/transportadora/TransportadoraCadastro.vue'
import VeiculoListagem from '@/views/cadastros/veiculo/VeiculoListagem.vue'
import VeiculoCadastro from '@/views/cadastros/veiculo/VeiculoCadastro.vue'
import NaturezaCustoListagem from '@/views/cadastros/natureza-custo/NaturezaCustoListagem.vue'
import NaturezaCustoCadastro from '@/views/cadastros/natureza-custo/NaturezaCustoCadastro.vue'
import CentroCustoOpListagem from '@/views/cadastros/custo-operacional/CentroCustoOpListagem.vue'
import CentroCustoOpCadastro from '@/views/cadastros/custo-operacional/CentroCustoOpCadastro.vue'
import LayoutImportacaoListagem from '@/views/cadastros/layout-importacao/LayoutImportacaoListagem'
import LayoutImportacaoCadastro from '@/views/cadastros/layout-importacao/LayoutImportacaoCadastro'
import AlmoxarifadoEstoque from '@/views/almoxarifado/estoque/EstoqueAlmoxarifadoListagem.vue'

// Relatorios
import RelCompraGado from '@/views/relatorios/RelCompraGado'
import RelApagar from '@/views/relatorios/RelApagar'
import RelAreceber from '@/views/relatorios/RelAreceber'
import RelCaixaLivro from '@/views/relatorios/RelCaixaLivro'
import RelCaixaMovimento from '@/views/relatorios/RelCaixaMovimento'
import RelCaixa from '@/views/relatorios/RelCaixa'
import RelRecebido from '@/views/relatorios/RelRecebido'
import RelPago from '@/views/relatorios/RelPago'
import RelAbate from '@/views/relatorios/RelAbate'
import RelAbateFechamento from '@/views/relatorios/RelAbateFechamento'
import RelVendas from '@/views/relatorios/RelVendas'
import RelPedidoVenda from '@/views/relatorios/RelPedidoVenda'
import RelNotaFiscal from '@/views/relatorios/RelNotaFiscal'
import RelOperacaoVenda from '@/views/relatorios/RelOperacaoVenda'
import RelGestaoCompras from '@/views/relatorios/RelGestaoCompras'
import RelMapaFiscal from '@/views/relatorios/RelMapaFiscal'
import RelEstoque from '@/views/relatorios/RelEstoque'
import RelProducaoFormula from '@/views/relatorios/RelProducaoFormula'

// Dashboards children
import AreceberProximosDezDias from '@/views/dashboard/AreceberProximosDezDias'
import ApagarProximosDezDias from '@/views/dashboard/ApagarProximosDezDias'
import PagoUltimosDezDias from '@/views/dashboard/PagoUltimosDezDias'
import RecebidoUltimosDezDias from '@/views/dashboard/RecebidoUltimosDezDias'
import FluxoCaixaDezDias from '@/views/dashboard/FluxoCaixaDezDias'
import MovimentoPeriodo from '@/views/dashboard/MovimentoPeriodo'
import DespesasPeriodo from '@/views/dashboard/DespesasPeriodo'
import VendasPeriodo from '@/views/dashboard/VendasPeriodo'
import CaixaMovimentoDia from '@/views/dashboard/CaixaMovimentoDia'
import RecebidoHoje from '@/views/dashboard/RecebidoHoje'
import PagoHoje from '@/views/dashboard/PagoHoje'
import PainelCancelamentos from '@/views/dashboard/PainelCancelamentos'

// DashBoard Vendedor
import DashboardVendedor from '@/views/dashboard/DashboardVendedor'
import DashboardMotorista from '@/views/dashboard/DashboardMotorista'

// Estratégia
import AnalyticsDashboard from '@/views/estrategia/AnalyticsDashboard'
import ComissionamentoDashboard from '@/views/estrategia/ComissionamentoDashboard'
import AnalyticsVendas from '@/views/estrategia/AnalyticsVendas'


// Consultas
import AreceberPorCliente from '@/views/consultas/AreceberPorCliente'

// Movimento
import ContasReceberListagem from '@/views/movimentos/contasreceber/AreceberListagem'
import ContasReceberCadastro from '@/views/movimentos/contasreceber/AreceberCadastro'
import ContasReceberAnalytics from '@/views/movimentos/contasreceber/AreceberAnalyticsView'
import ContasApagarListagem from '@/views/movimentos/contasapagar/ApagarListagem'
import ContasApagarCadastro from '@/views/movimentos/contasapagar/ApagarCadastro'
import ContasApagarAnalytics from '@/views/movimentos/contasapagar/ApagarAnalyticsView'
import ContasPagasListagem from '@/views/movimentos/contaspagas/PagasListagem'
import ContasRecebidasListagem from '@/views/movimentos/contasrecebidas/RecebidasListagem'
import CaixaPesquisa from '@/views/movimentos/caixa/CaixaPesquisa'
import CaixaLancamento from '@/views/movimentos/caixa/CaixaLancamento'
import CompraGadoListagem from '@/views/movimentos/compragado/CompraGadoListagem'
import CompraGadoCadastro from '@/views/movimentos/compragado/CompraGadoCadastro'
import ConciliacaoBancariaListagem from '@/views/financeiro/conciliacao-bancaria/ConciliacaoBancariaListagem'
import ConciliacaoBancariaCadastro from '@/views/financeiro/conciliacao-bancaria/ConciliacaoBancariaCadastro'
import ConferenciaFinanceiraListagem from '@/views/financeiro/conferencia-financeira/ConferenciaFinanceiraListagem'
import ConferenciaFinanceiraCadastro from '@/views/financeiro/conferencia-financeira/ConferenciaFinanceiraCadastro'
import ProducaoFormulaListagem from '@/views/producao/producao-formula/ProducaoFormulaListagem'
import ProducaoFormulaCadastro from '@/views/producao/producao-formula/ProducaoFormulaCadastro'
import ProducaoFormulaProcessoListagem from '@/views/producao/producao-formula-processo/ProducaoFormulaProcessoListagem'
import ProducaoFormulaProcessoCadastro from '@/views/producao/producao-formula-processo/ProducaoFormulaProcessoCadastro'
import ProducaoFormulaApontamentoCadastro from '@/views/producao/producao-formula-apontamento/ProducaoFormulaApontamentoCadastro'
import ProducaoFormulaRastreabilidadeListagem from '@/views/producao/producao-formula-rastreabilidade/ProducaoFormulaRastreabilidadeListagem'
import ProducaoFormulaRastreabilidadeCadastro from '@/views/producao/producao-formula-rastreabilidade/ProducaoFormulaRastreabilidadeCadastro'

//Vendas
import VendasListagem from '@/views/movimentos/vendas/VendaListagem'
import VendasCadastro from '@/views/movimentos/vendas/VendaCadastro'

//Compras
import ComprasListagem from '@/views/movimentos/compras/ComprasListagem'
import ComprasCadastro from '@/views/movimentos/compras/ComprasCadastro'
import CompraConferenciaListagem from '@/views/movimentos/compras/CompraConferenciaListagem'
import NfeDistribuicao from '@/views/movimentos/compras/NfeDistribuicao'

import PedidoVendaListagem from '@/views/movimentos/pedidovenda/PedidoVendaListagem'
import PedidoVendaCadastro from '@/views/movimentos/pedidovenda/PedidoVendaCadastro'
import PedidoVendaListagemWeb from '@/views/movimentos/pedidovenda/PedidoVendaListagemWeb'
import PedidoVendaCadastroWeb from '@/views/movimentos/pedidovenda/PedidoVendaCadastroWeb'
import PedidoVendaSeparacaoWeb from '@/views/movimentos/pedidovenda/PedidoVendaSeparacaoWeb'

// Estoque
import EstoqueDiversos from '@/views/estoque/EstoqueDiversos'
import EstoqueDashboard from '@/views/estoque/EstoqueDashboard'
import EstoqueProducao from '@/views/estoque/EstoqueProducao'
import MovimentoEtiqueta from '@/views/estoque/MovimentoEtiqueta'
import AjusteEstoqueListagem from '@/views/estoque/ajuste/AjusteEstoqueListagem'
import AjusteEstoqueCadastro from '@/views/estoque/ajuste/AjusteEstoqueCadastro'
import CentroEstoqueListagem from '@/views/estoque/centro-estoque/CentroEstoqueListagem.vue'
import CentroEstoqueCadastro from '@/views/estoque/centro-estoque/CentroEstoqueCadastro.vue'
import InventarioProdutosCadastro from '@/views/estoque/inventario/InventarioProdutosCadastro.vue'
import PedidoEtiquetaAvulsaListagem from '@/views/estoque/pedido-etiqueta-avulsa/PedidoEtiquetaAvulsaListagem.vue'
import EstoqueValidadeLotes from '@/views/estoque/EstoqueValidadeLotes'
import EstoqueAnaliseCustos from '@/views/estoque/EstoqueAnaliseCustos'

//PRODUCAO
import DashBoardProducao from '@/views/producao/DashBoardProducao'
import ProducaoFormulaDashboard from '@/views/producao/producao-dashboard/ProducaoDashboard'

import GrupoAcessoListagem from '@/views/seguranca/grupoacesso/GrupoAcessoListagem'
import GrupoAcessoCadastro from '@/views/seguranca/grupoacesso/GrupoAcessoCadastro'

import UsuarioListagem from '@/views/seguranca/usuario/UsuarioListagem'
import UsuarioCadastro from '@/views/seguranca/usuario/UsuarioCadastro'

// Ferramentas - REMOVIDO (modais abrem diretamente do HeaderDropdown)

import OrdemAbateListagem from '@/views/producao/ordemabate/OrdemAbateListagem'
import OrdemAbateCadastro from '@/views/producao/ordemabate/OrdemAbateCadastro'
import OrdemAbateColeta from '@/views/producao/ordemabate/OrdemAbateColeta'
import OrdemAbateDetalhes from '@/views/producao/ordemabate/OrdemAbateDetalhes'

//PRODUCAO RESUMO
import ResumoAbateListagem from '@/views/producao/resumoabate/ResumoAbateListagem'
import ResumoAbateCadastro from '@/views/producao/resumoabate/ResumoAbateCadastro'
import ResumoAbateDetalhes from '@/views/producao/resumoabate/ResumoAbateDetalhes'

//PEDIDO PRODUCAO
import PedidoProducaoListagem from '@/views/producao/pedidoproducao/PedidoProducaoListagem'
import PedidoProducaoCadastro from '@/views/producao/pedidoproducao/PedidoProducaoCadastro'

//ORDEM EXPEDICAO
import OrdemExpedicaoListagem from '@/views/expedicao/ordemexpedicao/OrdemExpedicaoListagem'
import OrdemExpedicaoCadastro from '@/views/expedicao/ordemexpedicao/OrdemExpedicaoCadastro'
import OrdemExpedicaoDetalhes from '@/views/expedicao/ordemexpedicao/OrdemExpedicaoDetalhes'
import RetiradaServicoListagem from '@/views/expedicao/retiradaServico/RetiradaServicoListagem'
import RetiradaServicoCadastro from '@/views/expedicao/retiradaServico/RetiradaServicoCadastro'

//EXPEDICAO VOLUMES (Ração/Granel)
import ExpedicaoVolumesListagem from '@/views/expedicao/volumes/ExpedicaoVolumesListagem'
import ExpedicaoVolumesCarregamento from '@/views/expedicao/volumes/ExpedicaoVolumesCarregamento'

// EXPEDICAO VENDAS (Matadouro / Frigorífico)
import ExpedicaoVendasListagem from '@/views/expedicao/vendas/ExpedicaoVendasListagem'
import ConferenciaVendasListagem from '@/views/expedicao/conferencia/ConferenciaVendasListagem'
import OrdemEntregaListagem from '@/views/expedicao/ordementrega/OrdemEntregaListagem'
import OrdemEntregaCadastro from '@/views/expedicao/ordementrega/OrdemEntregaCadastro'

//NOTA-FISCAL
//import NotaFiscalListagem from '@/views/faturamento/notafiscal/NotaFiscalListagem'
import Nfe from '@/views/faturamento/nfe/NfeListagem'
import NfeCadastro from '@/views/faturamento/nfe/NfeCadastro'
import BoletoRemessaListagem from '@/views/faturamento/boleto/BoletoRemessaListagem'
import BoletoRemessaCadastro from '@/views/faturamento/boleto/BoletoRemessaCadastro'
import BoletoRetornoListagem from '@/views/faturamento/boleto/BoletoRetornoListagem'
import BoletoRetornoCadastro from '@/views/faturamento/boleto/BoletoRetornoCadastro'
import DevolucaoFaturamentoListagem from '@/views/faturamento/devolucao/DevolucaoFaturamentoListagem'
import DevolucaoFaturamentoCadastro from '@/views/faturamento/devolucao/DevolucaoFaturamentoCadastro'
import DevolucaoConferenciaListagem from '@/views/faturamento/devolucao/DevolucaoConferenciaListagem'

//SEGURANCA
//import GrupoAcesso from '@/views/cadastros/seguranca/grupoacesso/GrupoAcessoListagem'

//AUDITORIA
import AreceberExcluidasListagem from '@/views/auditoria/AreceberExcluidasListagem'
import ApagarExcluidasListagem from '@/views/auditoria/ApagarExcluidasListagem'

//import GrupoAcessoCadastro from '@views/seguranca/grupoacesso/GrupoAcessoCadastro'


Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      //redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          // component: Dashboard
          // redirect: '/dashboard/painelgerencial',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/dashboard/executivo',
              name: 'Dashboard Executivo',
              component: DashboardExecutivoMobile
            },
            {
              path: '/dashboard/painelgerencial',
              name: 'Painel Gerencial',
              component: Dashboard
            },
            {
              path: '/dashboard/painelgerencial/areceberproximosdezdias',
              name: 'A Receber 10 Dias',
              component: AreceberProximosDezDias
            },
            {
              path: '/dashboard/painelgerencial/apagarproximosdezdias',
              name: 'A Pagar 10 Dias',
              component: ApagarProximosDezDias
            },
            {
              path: '/dashboard/painelgerencial/pagoultimosdezdias',
              name: 'Pago 10 Dias',
              component: PagoUltimosDezDias
            },
            {
              path: '/dashboard/painelgerencial/recebidoultimosdezdias',
              name: 'Recebido 10 Dias',
              component: RecebidoUltimosDezDias
            },
            {
              path: '/dashboard/painelgerencial/fluxocaixadezdias',
              name: 'Fluxo Caixa 10 Dias',
              component: FluxoCaixaDezDias
            },
            {
              path: '/dashboard/painelgerencial/movimentoperiodo',
              name: 'Movimento do Período',
              component: MovimentoPeriodo
            },
            {
              path: '/dashboard/painelgerencial/despesasperiodo',
              name: 'Despesas do Período',
              component: DespesasPeriodo
            },
            {
              path: '/dashboard/painelgerencial/painel-cancelamentos',
              name: 'Painel de Cancelamentos',
              component: PainelCancelamentos
            },
            {
              path: '/dashboard/painelgerencial/vendasperiodo',
              name: 'Vendas do Período',
              component: VendasPeriodo
            },
            {
              path: '/dashboard/painelgerencial/caixamovimentodia/:contaid',
              name: 'Movimento do Dia da Conta',
              component: CaixaMovimentoDia
            },
            {
              path: '/dashboard/painelgerencial/recebidoHoje',
              name: 'Recebimentos efetuados Hoje',
              component: RecebidoHoje
            },
            {
              path: '/dashboard/painelgerencial/pagoHoje',
              name: 'Pagamentos efetuados Hoje',
              component: PagoHoje
            },
            {
              path: '/dashboard/estoqueproducao',
              name: 'Estoque Vendedor',
              component: EstoqueProducao
            },
            {
              path: '/dashboard/estoquediversos',
              name: 'Painel Estoque',
              redirect: '/estoque/diversos'
            },

            {
              path: '/dashboard/painelproducao',
              name: 'Painel Producao',
              component: DashBoardProducao
            },
            {
              path: '/dashboard/vendedor',
              name: 'Painel Vendedor',
              component: DashboardVendedor
            },
            {
              path: '/dashboard/motorista',
              name: 'Painel Motorista',
              component: DashboardMotorista
            }

          ]
        },

        // GESTÃO ESTRATÉGICA
        {
          path: 'estrategia',
          name: 'Gestão Estratégica',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'analytics',
              name: 'CECFrigo Analytics',
              component: AnalyticsDashboard
            },
            {
              path: 'comissionamento',
              name: 'Simulador de Comissões',
              component: ComissionamentoDashboard
            },
            {
              path: 'analytics-vendas',
              name: 'Exportador de Vendas',
              component: AnalyticsVendas
            }
          ]
        },
        // FATURAMENTO - NF-e (adicionado automaticamente)
        {
          path: 'faturamento',
          name: 'Faturamento',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/faturamento/nfe/index',
              name: 'NFe - Lista',
              component: Nfe
            },
            {
              path: '/faturamento/nfe/cadastro/:id',
              name: 'NFe - Cadastro',
              component: NfeCadastro
            },
            {
              path: '/faturamento/remessa/index',
              name: 'Remessa de Boletos - Lista',
              component: BoletoRemessaListagem
            },
            {
              path: '/faturamento/remessa/cadastro/:id',
              name: 'Remessa de Boletos - Cadastro',
              component: BoletoRemessaCadastro
            },
            {
              path: '/faturamento/retorno/index',
              name: 'Retorno de Boletos - Lista',
              component: BoletoRetornoListagem
            },
            {
              path: '/faturamento/retorno/cadastro/:id',
              name: 'Retorno de Boletos - Cadastro',
              component: BoletoRetornoCadastro
            },
            {
              path: '/faturamento/devolucao/index',
              name: 'Devolução de Faturamento - Lista',
              component: DevolucaoFaturamentoListagem
            },
            {
              path: '/faturamento/devolucao/cadastro/:id',
              name: 'Devolução de Faturamento - Cadastro',
              component: DevolucaoFaturamentoCadastro
            },
            {
              path: '/faturamento/devolucao/conferencia',
              name: 'Conferencia de Devolucao',
              component: DevolucaoConferenciaListagem
            }
          ]
        },

        {
          path: 'auditoria',
          name: 'Auditoria',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'areceber-excluidas',
              name: 'Areceber Excluídas',
              component: AreceberExcluidasListagem
            },
            {
              path: 'apagar-excluidas',
              name: 'Apagar Excluídas',
              component: ApagarExcluidasListagem
            }
          ]
        },


        {

          path: 'cadastros',
          // redirect: '/cadastros/clientes/index',
          name: 'Cadastros',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/cadastros/clientes/index',
              name: 'Clientes',
              component: {
                render(c) { return c('router-view') }
              },
              children: [
                {
                  path: '/cadastros/clientes/index',
                  name: 'Lista',
                  component: Clientes
                },
                {
                  path: '/cadastros/clientes/edit/:id',
                  name: 'Alterações',
                  component: ClientesEdit
                },
                {
                  path: '/cadastros/clientes/novo',
                  name: 'Novo',
                  component: ClientesEdit
                }
              ]
            },
            {
              path: '/cadastros/produto',
              name: 'PRODUTO',
              redirect: '/cadastros/produto/listagem',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [

                {
                  path: '/cadastros/produto/index',
                  name: 'Lista de Produtos',
                  component: ProdutosListagem
                },
                {
                  path: '/cadastros/produto/edit/:id',
                  name: 'Produto Novo',
                  component: ProdutosCadastro
                },
                {
                  path: '/cadastros/produto/add',
                  name: 'Produto Alteração',
                  component: ProdutosCadastro
                }
              ]
            },
            {
              path: '/cadastros/vendedor',
              name: 'VENDEDOR',
              redirect: '/cadastros/vendedor/index',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/cadastros/vendedor/index',
                  name: 'Lista de VENDEDOR',
                  component: VendedorListagem
                },
                {
                  path: '/cadastros/vendedor/edit/:id',
                  name: 'Alteração do VENDEDOR',
                  component: VendedorCadastro
                },
                {
                  path: '/cadastros/vendedor/add',
                  name: 'Novo VENDEDOR',
                  component: VendedorCadastro
                }

              ]
            },


            {
              path: '/cadastros/cfop/index',
              name: 'CFOP',
              redirect: '/cadastros/cfop/index',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/cadastros/cfop/index',
                  name: 'Lista de CFOP',
                  component: CfopListagem
                },
                {
                  path: '/cadastros/cfop/edit/:id',
                  name: 'Alteração do CFOP',
                  component: CfopCadastro
                },
                {
                  path: '/cadastros/cfop/add',
                  name: 'Novo CFOP',
                  component: CfopCadastro
                }
              ]
            },
            {
              path: '/cadastros/tipomovimentacao',
              name: 'Tipo de Movimentação',
              redirect: '/cadastros/tipomovimentacao/index',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/cadastros/tipomovimentacao/index',
                  name: 'Lista de Tipos de Movimentação',
                  component: TipoMovimentacaoListagem
                },
                {
                  path: '/cadastros/tipomovimentacao/edit/:id',
                  name: 'Alteração do Tipo de Movimentação',
                  component: TipoMovimentacaoCadastro
                },
                {
                  path: '/cadastros/tipomovimentacao/add',
                  name: 'Novo Tipo de Movimentação',
                  component: TipoMovimentacaoCadastro
                }
              ]
            },
            // -- FUNCIONARIO
            {
              path: 'funcionario',
              name: 'Funcionarios',
              component: { render: c => c('router-view') },
              redirect: { name: 'Funcionarios - Lista' }, // se entrar só em /almoxarifado/departamento
              children: [
                {
                  path: 'index',
                  name: 'Funcionarios - Lista',
                  component: FuncionarioListagem
                },
                {
                  path: 'add',
                  name: 'Funcionarios - Novo',
                  component: FuncionarioCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Funcionarios - Alteração',
                  component: FuncionarioCadastro,
                  props: true
                }
              ]
            },
            // -- TRIBUTACAO ICMS
            {
              path: 'tributacao-icms',
              name: 'TributacaoIcms',
              component: { render: c => c('router-view') },
              redirect: { name: 'Tributação ICMS - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Tributação ICMS - Lista',
                  component: TributacaoIcmsListagem
                },
                {
                  path: 'add',
                  name: 'Tributação ICMS - Novo',
                  component: TributacaoIcmsCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Tributação ICMS - Alteração',
                  component: TributacaoIcmsCadastro,
                  props: true
                }
              ]
            },// -- CENTRO DE CUSTO
            {
              path: 'centrocusto',
              name: 'Centro de Custo',
              component: { render: c => c('router-view') },
              redirect: { name: 'Centro de Custo - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Centro de Custo - Lista',
                  component: CentroCustoListagem
                },
                {
                  path: 'add',
                  name: 'Centro de Custo - Novo',
                  component: CentroCustoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Centro de Custo - Alteração',
                  component: CentroCustoCadastro,
                  props: true
                }
              ]
            }, //HISTORICO DO CASIXA
            {
              path: 'historico',
              name: 'Historicos do Caixa',
              component: { render: c => c('router-view') },
              redirect: { name: 'Historicos do Caixa - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Historicos do Caixa - Lista',
                  component: HistoricoListagem
                },
                {
                  path: 'add',
                  name: 'Historicos - Novo',
                  component: HistoricoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Historicos - Alteração',
                  component: HistoricoCadastro,
                  props: true
                }
              ]
            },
            {
              path: '/cadastros/tipomovimentacao',
              name: 'TIPO MOVIMENTACAO',
              redirect: '/cadastros/tipomovimentacao/index',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [
                {
                  path: '/cadastros/tipomovimentacao/index',
                  name: 'Lista de Tipo de Movimentação',
                  component: TipoMovimentacaoListagem
                },
                {
                  path: '/cadastros/tipomovimentacao/edit/:id',
                  name: 'Alteração do Tipo de Movimentação',
                  component: TipoMovimentacaoCadastro
                },
                {
                  path: '/cadastros/tipomovimentacao/add',
                  name: 'Novo Tipo de Movimentação',
                  component: TipoMovimentacaoCadastro
                }
              ]
            },
            // BANCO - AGÊNCIAS - CONTAS
            {
              path: 'banco',
              name: 'Bancos - Agências - Contas',
              component: { render: c => c('router-view') },
              redirect: { name: 'Bancos - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Bancos - Lista',
                  component: () => import('@/views/cadastros/banco/BancoListagem.vue')
                },
                {
                  path: 'cadastro/:id',
                  name: 'Bancos - Cadastro',
                  component: () => import('@/views/cadastros/banco/BancoCadastro.vue'),
                  props: true
                }
              ]
            },
            // -- GRUPO DE CONTAS A PAGAR
            {
              path: 'grupo-apagar',
              name: 'GrupoApagar',
              component: { render: c => c('router-view') },
              redirect: { name: 'Grupo a Pagar - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Grupo a Pagar - Lista',
                  component: GrupoApagarListagem
                },
                {
                  path: 'add',
                  name: 'Grupo a Pagar - Novo',
                  component: GrupoApagarCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Grupo a Pagar - Alteração',
                  component: GrupoApagarCadastro,
                  props: true
                }
              ]
            },
            // -- GRUPO DE CONTAS A RECEBER
            {
              path: 'grupo-areceber',
              name: 'GrupoAreceber',
              component: { render: c => c('router-view') },
              redirect: { name: 'Grupo a Receber - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Grupo a Receber - Lista',
                  component: GrupoAreceberListagem
                },
                {
                  path: 'add',
                  name: 'Grupo a Receber - Novo',
                  component: GrupoAreceberCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Grupo a Receber - Alteração',
                  component: GrupoAreceberCadastro,
                  props: true
                }
              ]
            },
            // -- GRUPO DE PRODUTO
            {
              path: 'grupo-produto',
              name: 'GrupoProduto',
              component: { render: c => c('router-view') },
              redirect: { name: 'GrupoProdutoListagem' },
              children: [
                {
                  path: 'index',
                  name: 'GrupoProdutoListagem',
                  component: GrupoProdutoListagem
                },
                {
                  path: 'add',
                  name: 'GrupoProdutoAdicionar',
                  component: GrupoProdutoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'GrupoProdutoEditar',
                  component: GrupoProdutoCadastro,
                  props: true
                }
              ]
            },
            {
              path: 'layout-importacao',
              name: 'Layout de Importação',
              component: { render: c => c('router-view') },
              redirect: { name: 'Layout de Importação - Lista' },
              children: [
                {
                  path: 'list',
                  name: 'Layout de Importação - Lista',
                  component: LayoutImportacaoListagem
                },
                {
                  path: 'add',
                  name: 'Layout de Importação - Novo',
                  component: LayoutImportacaoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Layout de Importação - Alteração',
                  component: LayoutImportacaoCadastro,
                  props: true
                }
              ]
            },
            // -- SUBGRUPO DE PRODUTO
            {
              path: 'subgrupo-produto',
              name: 'SubgrupoProduto',
              component: { render: c => c('router-view') },
              redirect: { name: 'SubgrupoProdutoListagem' },
              children: [
                {
                  path: 'index',
                  name: 'SubgrupoProdutoListagem',
                  component: SubgrupoProdutoListagem
                },
                {
                  path: 'add',
                  name: 'SubgrupoProdutoAdicionar',
                  component: SubgrupoProdutoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'SubgrupoProdutoEditar',
                  component: SubgrupoProdutoCadastro,
                  props: true
                }
              ]
            },
            // -- TIPO DE BENEFICIAMENTO
            {
              path: 'tipo-beneficiamento',
              name: 'TipoBeneficiamento',
              component: { render: c => c('router-view') },
              redirect: { name: 'TipoBeneficiamentoListagem' },
              children: [
                {
                  path: 'index',
                  name: 'TipoBeneficiamentoListagem',
                  component: TipoBeneficiamentoListagem
                },
                {
                  path: 'add',
                  name: 'TipoBeneficiamentoAdicionar',
                  component: TipoBeneficiamentoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'TipoBeneficiamentoEditar',
                  component: TipoBeneficiamentoCadastro,
                  props: true
                }
              ]
            },
            // -- NATUREZA CUSTO
            {
              path: 'natureza-custo',
              name: 'NaturezaCusto',
              component: { render: c => c('router-view') },
              redirect: { name: 'NaturezaCustoListagem' },
              children: [
                {
                  path: 'listagem',
                  name: 'NaturezaCustoListagem',
                  component: NaturezaCustoListagem
                },
                {
                  path: 'add',
                  name: 'NaturezaCustoAdicionar',
                  component: NaturezaCustoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'NaturezaCustoEditar',
                  component: NaturezaCustoCadastro,
                  props: true
                }

              ]
            },
            // -- CUSTO OPERACIONAL TEMPLATE
            {
              path: 'custo-operacional',
              name: 'CustoOperacional',
              component: { render: c => c('router-view') },
              redirect: { name: 'CustoOperacionalListagem' },
              children: [
                {
                  path: 'listagem',
                  name: 'CustoOperacionalListagem',
                  component: CentroCustoOpListagem
                },
                {
                  path: 'add',
                  name: 'CustoOperacionalAdicionar',
                  component: CentroCustoOpCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'CustoOperacionalEditar',
                  component: CentroCustoOpCadastro,
                  props: true
                }
              ]
            },
            // -- TIPO DE PRODUTO
            {
              path: 'tipo-produto',
              name: 'TipoProduto',
              component: { render: c => c('router-view') },
              redirect: { name: 'TipoProdutoListagem' },
              children: [
                {
                  path: 'index',
                  name: 'TipoProdutoListagem',
                  component: TipoProdutoListagem
                },
                {
                  path: 'add',
                  name: 'TipoProdutoAdicionar',
                  component: TipoProdutoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'TipoProdutoEditar',
                  component: TipoProdutoCadastro,
                  props: true
                }
              ]
            },
            // -- TRANSPORTADORA
            {
              path: 'transportadora',
              name: 'Transportadora',
              component: { render: c => c('router-view') },
              redirect: { name: 'Transportadora - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Transportadora - Lista',
                  component: TransportadoraListagem
                },
                {
                  path: 'add',
                  name: 'Transportadora - Novo',
                  component: TransportadoraCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Transportadora - Alteração',
                  component: TransportadoraCadastro,
                  props: true
                }
              ]
            },
            // -- VEÍCULO
            {
              path: 'veiculo',
              name: 'Veiculo',
              component: { render: c => c('router-view') },
              redirect: { name: 'VeiculoListagem' },
              children: [
                {
                  path: 'index',
                  name: 'VeiculoListagem',
                  component: VeiculoListagem
                },
                {
                  path: 'add',
                  name: 'VeiculoCadastroNovo',
                  component: VeiculoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'VeiculoCadastroEditar',
                  component: VeiculoCadastro,
                  props: true
                }
              ]
            },
          ]
        },
        // ===== Bloco de rotas do ALMOXARIFADO =====
        {
          path: 'almoxarifado',
          name: 'Almoxarifado',
          component: { render: c => c('router-view') },
          redirect: { name: 'Almoxarife - Manutenção' }, // se entrar só em /almoxarifado
          children: [

            // -- MANUTENÇÃO (almoxarife)
            {
              path: 'requisicao',
              name: 'Almoxarife',
              component: { render: c => c('router-view') },
              redirect: { name: 'Almoxarife - Manutenção' }, // se entrar só em /almoxarifado/requisacao
              children: [
                {
                  path: 'index',
                  name: 'Almoxarife - Manutenção',
                  component: AlmoxarifadoListagem
                  // /almoxarifado/requisacao/index
                },
                {
                  path: 'edit/:id',
                  name: 'Atendimento da Requisição',
                  component: AlmoxarifadoAtendimento,
                  props: true,
                  alias: 'atendimento/:id' // também aceita /almoxarifado/requisacao/atendimento/:id
                },

                // -- MINHAS REQUISIÇÕES (usuário)
                {
                  path: 'minhasrequisicoes',
                  name: 'Minhas Requisições',
                  component: { render: c => c('router-view') },
                  redirect: { name: 'Minhas Requisições - Lista' }, // se entrar só em /.../minhasrequisicoes
                  children: [
                    {
                      path: 'index',
                      name: 'Minhas Requisições - Lista',
                      component: MinhasRequisicoesListagem
                      // /almoxarifado/requisacao/minhasrequisicoes/index
                    },
                    {
                      path: 'add',
                      name: 'Minhas Requisições - Nova',
                      component: MinhasReqisicoesCadastro
                      // /almoxarifado/requisacao/minhasrequisicoes/add
                    },
                    {
                      path: 'edit/:id',
                      name: 'Minhas Requisições - Alteração',
                      component: MinhasReqisicoesCadastro,
                      props: true
                      // /almoxarifado/requisacao/minhasrequisicoes/edit/:id
                    }
                  ]
                }
              ]
            },
            // -- ESTQOEU
            {
              path: 'estoque',
              name: 'Estoque Almox',
              component: { render: c => c('router-view') },
              redirect: { name: 'Estoque Almoxarifado - Lista' }, // se entrar só em /almoxarifado/bens
              children: [
                {
                  path: 'index',
                  name: 'Estoque Almoxarifado - Lista',
                  component: AlmoxarifadoEstoque
                }
              ]
            },
            // -- BENS
            {
              path: 'bens',
              name: 'Bens',
              component: { render: c => c('router-view') },
              redirect: { name: 'Bens - Lista' }, // se entrar só em /almoxarifado/bens
              children: [
                {
                  path: 'index',
                  name: 'Bens - Lista',
                  component: BensListagem
                },
                {
                  path: 'add',
                  name: 'Bens - Novo',
                  component: BensCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Bens - Alteração',
                  component: BensCadastro,
                  props: true
                }
              ]
            },

            // -- DEPARTAMENTOS
            {
              path: 'departamento',
              name: 'Departamentos',
              component: { render: c => c('router-view') },
              redirect: { name: 'Departamentos - Lista' }, // se entrar só em /almoxarifado/departamento
              children: [
                {
                  path: 'index',
                  name: 'Departamentos - Lista',
                  component: DepartamentoListagem
                },
                {
                  path: 'add',
                  name: 'Departamentos - Novo',
                  component: DepartamentoCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Departamentos - Alteração',
                  component: DepartamentoCadastro,
                  props: true
                }
              ]
            },



            // -- INVENTÁRIO
            {
              path: 'inventario',
              name: 'Inventário',
              component: { render: c => c('router-view') },
              redirect: { name: 'Inventário - Lista' }, // se entrar só em /almoxarifado/inventario
              children: [
                {
                  path: 'index',
                  name: 'Inventário - Lista',
                  component: AlmoxarifadoInventarioListagem
                },
                {
                  path: 'add',
                  name: 'Inventário - Novo',
                  component: AlmoxarifadoInventarioCadastro
                  // TODO: quando existir InventarioCadastro.vue, ajustar o import
                },
                {
                  path: 'edit/:id',
                  name: 'Inventário - Alteração',
                  component: AlmoxarifadoInventarioCadastro,
                  props: true
                }
              ]
            }
          ]
        },
        {
          path: 'movimentos',
          name: 'Movimentos',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/movimentos/contasreceber/listagem',
              name: 'Módulo de Contas a Receber',
              component: ContasReceberListagem
            },
            {
              path: '/movimentos/contasrecebidas/listagem',
              name: 'Contas RECEBIDAs - Pesquisa',
              component: ContasRecebidasListagem
            },
            {
              path: '/movimentos/contasreceber/novo',
              name: 'Contas a Receber - Novo',
              component: ContasReceberCadastro
            },
            {
              path: '/movimentos/contasreceber/edit/:id',
              name: 'Contas a Receber - Alteração',
              component: ContasReceberCadastro
            },
            {
              path: '/movimentos/contasreceber/analytics',
              name: 'Contas a Receber - Painel Analitico',
              component: ContasReceberAnalytics
            },
            {
              path: '/movimentos/contasapagar/listagem',
              name: 'Módulo de Contas a Pagar',
              component: ContasApagarListagem
            },
            {
              path: '/movimentos/contasapagar/novo',
              name: 'Contas a Pagar - Novo',
              component: ContasApagarCadastro
            },
            {
              path: '/movimentos/contasapagar/edit/:id',
              name: 'Contas a Pagar - Alteração',
              component: ContasApagarCadastro
            },
            {
              path: '/movimentos/contasapagar/analytics',
              name: 'Contas a Pagar - Painel Analitico',
              component: ContasApagarAnalytics
            },
            {
              path: '/movimentos/contaspagas/listagem',
              name: 'Contas PAGAS - Pesquisa',
              component: ContasPagasListagem
            },
            {
              path: '/movimentos/caixa/pesquisa',
              name: 'Caixa Interno \ Bancário',
              component: CaixaPesquisa
            },
            {
              path: '/movimentos/caixa/lancamento/:id',
              name: 'CAIXA LANÇAMENTO',
              component: CaixaLancamento
            },
            {
              path: '/movimentos/vendas/listagem',
              name: 'Módulo de Vendas',
              component: VendasListagem
            },
            {
              path: '/movimentos/vendas/edit/:id',
              name: 'Alteração da venda',
              component: VendasCadastro
            },
            {
              path: '/movimentos/vendas/add',
              name: 'Nova Venda',
              component: VendasCadastro
            },
            {
              path: '/movimentos/pedidovenda/listagem',
              name: 'Módulo Pedido de Vendas',
              component: PedidoVendaListagem
            },
            {
              path: '/movimentos/pedidovenda/edit/:id',
              name: 'Alteração do Pedido',
              component: PedidoVendaCadastro
            },
            {
              path: '/movimentos/pedidovenda/add',
              name: 'Novo Pedido',
              component: PedidoVendaCadastro
            },
            {
              path: '/movimentos/pedidovendaweb/listagem',
              name: 'Módulo Pedido de Vendas Web',
              component: PedidoVendaListagemWeb
            },
            {
              path: '/movimentos/pedidovendaweb/edit/:id',
              name: 'Alteração do Pedido Web',
              component: PedidoVendaCadastroWeb
            },
            {
              path: '/movimentos/pedidovendaweb/add',
              name: 'Novo Pedido Web',
              component: PedidoVendaCadastroWeb
            },
            {
              path: '/movimentos/pedidovendaweb/separacao',
              name: 'Separacao de Pedidos Web',
              component: PedidoVendaSeparacaoWeb
            },
            {
              path: '/movimentos/compras/listagem',
              name: 'Compras',
              component: ComprasListagem
            },
            {
              path: '/movimentos/compras/conferencia',
              name: 'Conferência de Compras',
              component: CompraConferenciaListagem
            },
            {
              path: '/movimentos/compras/edit/:id',
              name: 'Alteração da Compra',
              component: ComprasCadastro
            },
            {
              path: '/movimentos/compras/add',
              name: 'Nova Compra',
              component: ComprasCadastro
            },
            {
              path: '/movimentos/compras/distribuicao',
              name: 'Distribuição NF-e',
              component: NfeDistribuicao
            },
            {
              path: '/movimentos/compragado/novo',
              name: 'Compra de Gado - Novo',
              component: CompraGadoCadastro
            },
            {
              path: '/movimentos/compragado/edit/:id',
              name: 'Compra de Gado - ALTERAÇÂO',
              component: CompraGadoCadastro
            },
            {
              path: '/movimentos/compragado/listagem',
              name: 'Compra de Gado - Pesquisa',
              component: CompraGadoListagem
            },
            {
              path: '/movimentos/conciliacao-bancaria/listagem',
              name: 'Conciliação Bancária - Lista',
              component: ConciliacaoBancariaListagem
            },
            {
              path: '/movimentos/conciliacao-bancaria/add',
              name: 'Conciliação Bancária - Novo',
              component: ConciliacaoBancariaCadastro
            },
            {
              path: '/movimentos/conciliacao-bancaria/edit/:id',
              name: 'Conciliação Bancária - Alteração',
              component: ConciliacaoBancariaCadastro,
              props: true
            },
            {
              path: '/movimentos/conferencia-financeira/listagem',
              name: 'Conferência Financeira - Listagem',
              component: ConferenciaFinanceiraListagem
            },
            {
              path: '/movimentos/conferencia-financeira/add',
              name: 'Conferência Financeira - Cadastro',
              component: ConferenciaFinanceiraCadastro
            },
            {
              path: '/movimentos/conferencia-financeira/edit/:id',
              name: 'Conferência Financeira - Alteração',
              component: ConferenciaFinanceiraCadastro,
              props: true
            }/*,
            {
              path: '/movimentos/notafiscal/listagem',
              name: 'Nota Fiscal - Pesquisa',
              component: NotaFiscalListagem
            }*/
          ]
        },
        {
          path: 'consultas',
          name: 'Consultas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/consultas/areceberporcliente',
              name: 'Consulta de Débitos do Cliente',
              component: AreceberPorCliente
            }
          ]
        },
        {
          path: 'relatorios',
          redirect: '/relatorios/relcompragado',
          name: 'Relatorios',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/relatorios/relvendas',
              name: 'Relatório de Vendas',
              component: RelVendas
            },
            {
              path: '/relatorios/relpedidovenda',
              name: 'Relatório de Pedidos de Venda',
              component: RelPedidoVenda
            },
            {
              path: '/relatorios/relnotafiscal',
              name: 'Relatorio de Notas Fiscais',
              component: RelNotaFiscal
            },
            {
              path: '/relatorios/reloperacaovenda',
              name: 'Relatorio Operacional de Vendas',
              component: RelOperacaoVenda
            },
            {
              path: '/relatorios/relgestaocompras',
              name: 'Rel. Compras',
              component: RelGestaoCompras
            },
            {
              path: '/relatorios/relmapafiscal',
              name: 'Rel. Fiscal',
              component: RelMapaFiscal
            },
            {
              path: '/relatorios/relabate',
              name: 'Abate',
              component: RelAbate
            },
            {
              path: '/relatorios/relabatefechamento',
              name: 'Fechamento do Abate',
              component: RelAbateFechamento
            },
            {
              path: '/relatorios/relcompragado',
              name: 'Compra de Gado',
              component: RelCompraGado
            },
            {
              path: '/relatorios/relapagar',
              name: 'Contas a Pagar',
              component: RelApagar
            },
            {
              path: '/relatorios/relpago',
              name: 'Contas Pagas',
              component: RelPago
            },
            {
              path: '/relatorios/relareceber',
              name: 'Contas a Receber',
              component: RelAreceber
            },
            {
              path: '/relatorios/relrecebido',
              name: 'Contas Recebidas',
              component: RelRecebido
            },
            {
              path: '/relatorios/relcaixalivro',
              name: 'Livro Caixa',
              component: RelCaixaLivro
            },
            {
              path: '/relatorios/relcaixamovimento',
              name: 'Movimento do Caixa',
              component: RelCaixaMovimento
            },
            {
              path: '/relatorios/relcaixa',
              name: 'Relatório de Caixa',
              component: RelCaixa
            },
            {
              path: '/relatorios/relestoque',
              name: 'Relatório de Estoque',
              component: RelEstoque
            },
            {
              path: '/relatorios/relproducaoformula',
              name: 'Relatório de Produção',
              component: RelProducaoFormula
            }
          ]
        },
        {
          path: 'estoque',
          name: 'Estoque',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/estoque/dashboard',
              name: 'Dashboard de Estoque',
              component: EstoqueDashboard
            },
            {
              path: '/estoque/diversos',
              name: 'Estoque Diversos',
              component: EstoqueDiversos
            },
            {
              path: '/estoque/producao',
              name: 'Estoque Producao',
              component: EstoqueProducao
            },
            {
              path: '/estoque/movimentoetiqueta',
              name: 'Movimento da Etiqueta',
              component: MovimentoEtiqueta
            },
            {
              path: '/estoque/validade-lotes',
              name: 'Validade de Lotes',
              component: EstoqueValidadeLotes
            },
            {
              path: '/estoque/analise-custos',
              name: 'Análise de Custos',
              component: EstoqueAnaliseCustos
            },
            {
              path: 'ajuste',
              name: 'AjusteEstoque',
              component: { render: c => c('router-view') },
              redirect: { name: 'Ajuste de Estoque - Lista' },
              children: [
                {
                  path: 'index',
                  name: 'Ajuste de Estoque - Lista',
                  component: AjusteEstoqueListagem
                },
                {
                  path: 'add',
                  name: 'Ajuste de Estoque - Novo',
                  component: AjusteEstoqueCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'Ajuste de Estoque - Alteração',
                  component: AjusteEstoqueCadastro,
                  props: true
                }
              ]
            },
            {
              path: 'centro-estoque',
              name: 'CentroEstoque',
              component: { render: c => c('router-view') },
              redirect: { name: 'CentroEstoqueListagem' },
              children: [
                {
                  path: 'index',
                  name: 'CentroEstoqueListagem',
                  component: CentroEstoqueListagem
                },
                {
                  path: 'add',
                  name: 'CentroEstoqueAdicionar',
                  component: CentroEstoqueCadastro
                },
                {
                  path: 'edit/:id',
                  name: 'CentroEstoqueEditar',
                  component: CentroEstoqueCadastro,
                  props: true
                }
              ]
            },
            {
              path: '/estoque/inventario-produtos',
              name: 'Inventário de Produtos',
              component: InventarioProdutosCadastro
            },
            {
              path: 'pedido-etiqueta-avulsa',
              name: 'PedidoEtiquetaAvulsa',
              component: { render: c => c('router-view') },
              redirect: { name: 'PedidoEtiquetaAvulsaListagem' },
              children: [
                {
                  path: 'index',
                  name: 'PedidoEtiquetaAvulsaListagem',
                  component: PedidoEtiquetaAvulsaListagem
                }
              ]
            }
          ]
        },
        {
          path: 'seguranca',
          name: 'Segurança',
          redirect: '/seguranca/grupoacesso/index',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/seguranca/grupoacesso/index',
              name: 'Grupo de Acesso',
              component: GrupoAcessoListagem
            },
            {
              path: '/seguranca/grupoacesso/edit/:id',
              name: 'Grupo Acesso Alteração',
              component: GrupoAcessoCadastro
            },
            {
              path: '/seguranca/grupoacesso/add',
              name: 'Grupo Acesso Novo Cadastro',
              component: GrupoAcessoCadastro
            },
            {
              path: '/seguranca/usuario/index',
              name: 'Usuários',
              component: UsuarioListagem
            },
            {
              path: '/seguranca/usuario/edit/:id',
              name: 'Usuário Alteração',
              component: UsuarioCadastro
            },
            {
              path: '/seguranca/usuario/add',
              name: 'Usuário Novo Cadastro',
              component: UsuarioCadastro
            }
          ]
        },
        {
          path: 'producao',
          name: 'Producao',
          redirect: '/producao/ordemabate/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/ordemabate/listagem',
              name: 'Ordem de Abate',
              component: OrdemAbateListagem
            },
            {
              path: '/producao/ordemabate/edit/:id',
              name: 'Alteração Ordem de Abate',
              component: OrdemAbateCadastro
            },
            {
              path: '/producao/ordemabate/add',
              name: 'Nova Ordem de Abate',
              component: OrdemAbateCadastro
            },
            {
              path: '/producao/ordemabate/coleta/:id',
              name: 'Ordem de Abate - Coleta',
              component: OrdemAbateColeta
            },
            {
              path: '/producao/ordemabate/detalhes/:id',
              name: 'Ordem de Abate - Mais Detalhes',
              component: OrdemAbateDetalhes
            }

          ]
        },
        {
          path: 'producaoResumo',
          name: 'Resumo Produção',
          redirect: '/producao/resumo/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/resumo/listagem',
              name: 'Resumo da Produção',
              component: ResumoAbateListagem
            },
            {
              path: '/producao/resumo/edit/:id',
              name: 'Alteração do Resumo da Produção',
              component: ResumoAbateCadastro
            },
            {
              path: '/producao/resumo/add',
              name: 'Cadastro do Resumo da Produção',
              component: ResumoAbateCadastro
            },
            {
              path: '/producao/resumo/detalhes/:id',
              name: 'Resumo da Produção - Mais Detalhes',
              component: ResumoAbateDetalhes
            }

          ]
        },
        {
          path: 'pedidoProducao',
          name: 'Pedido de Produção',
          redirect: '/producao/pedido/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/pedido/listagem',
              name: 'Pedido de Produção - Listagem',
              component: PedidoProducaoListagem
            },
            {
              path: '/producao/pedido/cadastro/edit/:id',
              name: 'Pedido de Produção - Alteração',
              component: PedidoProducaoCadastro
            },
            {
              path: '/producao/pedido/cadastro/add',
              name: 'Pedido de Produção - Novo',
              component: PedidoProducaoCadastro
            }
          ]
        },
        {
          path: 'producaoFormula',
          name: 'Produção por Fórmula',
          redirect: '/producao/formula/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/formula/listagem',
              name: 'Produção por Fórmula - Listagem',
              component: ProducaoFormulaListagem
            },
            {
              path: '/producao/formula/edit/:id',
              name: 'Produção por Fórmula - Alteração',
              component: ProducaoFormulaCadastro,
              props: true
            },
            {
              path: '/producao/formula/add',
              name: 'Produção por Fórmula - Novo',
              component: ProducaoFormulaCadastro
            }
          ]
        },
        {
          path: '/producao/formula/dashboard',
          name: 'Produção por Fórmula - Dashboard',
          component: ProducaoFormulaDashboard
        },
        {
          path: 'producaoFormulaProcesso',
          name: 'Processo de Produção por Fórmula',
          redirect: '/producao/formula-processo/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/formula-processo/listagem',
              name: 'Processo de Produção por Fórmula - Listagem',
              component: ProducaoFormulaProcessoListagem
            },
            {
              path: '/producao/formula-processo/edit/:id',
              name: 'Processo de Produção por Fórmula - Alteração',
              component: ProducaoFormulaProcessoCadastro,
              props: true
            },
            {
              path: '/producao/formula-processo/add',
              name: 'Processo de Produção por Fórmula - Novo',
              component: ProducaoFormulaProcessoCadastro
            },
            {
              path: '/producao/formula-processo/apontamento/:processoId',
              name: 'Processo de Produção por Fórmula - Apontamento',
              component: ProducaoFormulaApontamentoCadastro,
              props: true
            }
          ]
        },
        {
          path: 'producaoFormulaRastreabilidade',
          name: 'Rastreabilidade Produção por Fórmula',
          redirect: '/producao/formula-rastreabilidade/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/producao/formula-rastreabilidade/listagem',
              name: 'Produção por Fórmula - Rastreabilidade - Listagem',
              component: ProducaoFormulaRastreabilidadeListagem
            },
            {
              path: '/producao/formula-rastreabilidade/cadastro/:tipo/:id',
              name: 'Produção por Fórmula - Rastreabilidade - Detalhamento',
              component: ProducaoFormulaRastreabilidadeCadastro,
              props: true
            }
          ]
        },
        {
          path: 'expedicao',
          name: 'Ordem de Expedição',
          //redirect: '/ordemexpedicao/listagem',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/expedicao/ordemexpedicao/listagem',
              name: 'Ordem de Expedição Listagem',
              component: OrdemExpedicaoListagem
            },
            {
              path: '/expedicao/ordemexpedicao/edit/:id',
              name: 'Alteração da Ordem de Expediçao',
              component: OrdemExpedicaoCadastro
            },
            {
              path: '/expedicao/ordemexpedicao/add',
              name: 'Cadastro da Ordem de Expedição',
              component: OrdemExpedicaoCadastro
            },
            {
              path: '/expedicao/retiradaservico/listagem',
              name: 'Retirada Serviço Listagem',
              component: RetiradaServicoListagem
            },
            {
              path: '/expedicao/retiradaservico/edit/:id',
              name: 'Alteração da Retirada de Serviço',
              component: RetiradaServicoCadastro
            },
            {
              path: '/expedicao/retiradaservico/add',
              name: 'Cadastro da Retirada de Serviço',
              component: RetiradaServicoCadastro
            },
            // EXPEDIÇÃO VOLUMES
            {
              path: '/expedicao/volumes/listagem',
              name: 'Expedição de Volumes - Listagem',
              component: ExpedicaoVolumesListagem
            },
            {
              path: 'volumes/carregamento/:id',
              name: 'Carregamento de Volumes',
              component: ExpedicaoVolumesCarregamento
            },
            {
              path: 'vendas/index',
              name: 'Expedição de Vendas',
              component: ExpedicaoVendasListagem
            },
            {
              path: 'conferencia/vendas/index',
              name: 'Conferencia de Vendas',
              component: ConferenciaVendasListagem
            },
            {
              path: '/expedicao/ordementrega/listagem',
              name: 'Ordem de Entrega Listagem',
              component: OrdemEntregaListagem
            },
            {
              path: '/expedicao/ordementrega/edit/:id',
              name: 'Alteracao da Ordem de Entrega',
              component: OrdemEntregaCadastro
            },
            {
              path: '/expedicao/ordementrega/add',
              name: 'Cadastro da Ordem de Entrega',
              component: OrdemEntregaCadastro
            }

          ]
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'social-buttons',
              name: 'Social Buttons',
              component: SocialButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'senha',
          name: 'Alterar Senha',
          component: Senha
        }

      ]
    }
  ]
})

/** =========================
 *  Helpers & estado interno
 *  ========================= */
const PUBLIC_ROUTES = new Set(['/pages/login', '/pages/404'])

// Rotas que não podem ser configuradas como tela inicial
const ROTAS_PROIBIDAS = ['/pages/login', '/pages/404', '/pages/500', '/pages/register']

const normalize = (path = '') =>
(path
  .replace(/\/(edit|add|novo|apontamento|detalhe|detalhes|listagem)(\/\d+)?$/i, '')
  .replace(/\/index$/i, '')
  .replace(/\/\d+$/i, '')
  .replace(/\/+$/, '') || '/')

const computeHome = (permissions = []) => {
  // [1] Tenta usar tela inicial configurada (com validação de segurança)
  const telaConfigurada = store.getters['menu/telaInicial']

  if (telaConfigurada && typeof telaConfigurada === 'string') {
    const telaSanitizada = telaConfigurada.trim()

    // Validação 1: Não pode ser rota proibida
    if (ROTAS_PROIBIDAS.includes(telaSanitizada)) {
      console.error('[SECURITY] Tentativa de usar rota proibida como home:', telaSanitizada)
    } else {
      // Validação 2: Verifica permissão (original + normalizada)
      const telaNormalizada = normalize(telaSanitizada)

      if (hasPermissionCached(telaSanitizada) || hasPermissionCached(telaNormalizada)) {
        // ✅ SEGURO: Permissão validada
        return telaSanitizada
      } else {
        // ⚠️ ALERTA DE SEGURANÇA: Tela configurada sem permissão
        console.warn('[SECURITY] Tela inicial configurada sem permissão:', telaSanitizada)
        console.warn('[SECURITY] Usuário:', localStorage.getItem('login'), 'Timestamp:', new Date().toISOString())
      }
    }
  }

  // [2] Fallback para lógica atual (SEMPRE SEGURO)
  const hasGerencial = permissions.includes('/dashboard/painelgerencial')
  if (hasGerencial) return '/dashboard/painelgerencial'

  const vendedorId = Number(localStorage.getItem('vendedorId'))
  if (vendedorId !== 100) return '/dashboard/vendedor'

  return '/estoque/diversos'
}

// ===== [1] Cache de permissões (Set + versões normalizadas) =====
let _perms = []
let _permsSet = new Set()
let _permsNormSet = new Set()

const setPermissionsCache = (perms = []) => {
  _perms = perms || []
  _permsSet = new Set(_perms)
  _permsNormSet = new Set(_perms.map(p => normalize(p)))
}

const hasPermissionCached = (toPath) => {
  const toNorm = normalize(toPath)
  // hit rápido
  if (_permsSet.has(toPath) || _permsNormSet.has(toNorm)) return true
  // prefix match controlado
  for (const p of _permsSet) if (toPath.startsWith(p + '/')) return true
  for (const pn of _permsNormSet) if (toNorm.startsWith(pn + '/')) return true
  return false
}

// lock simples para não disparar GERAR_LISTA em paralelo
let loadingPerms = null
const ensurePermissions = async () => {
  // [1] Verifica se tem hash válido no Vuex
  const hashValido = store.getters['menu/isHashValido']
  const perms = store.getters['menu/userPermissions']

  if (hashValido && perms && perms.length) {
    // ✅ CACHE HIT: Hash válido, usa memória (0 HTTP requests)
    setPermissionsCache(perms)
    return perms
  }

  // [2] Cache miss ou hash inválido: recarrega do backend
  if (hashValido === false && perms && perms.length) {
    // ⚠️ Hash inválido com dados presentes = possível manipulação
    console.error('[SECURITY] Hash inválido detectado. Recarregando permissões...')
    const usuarioLogin = localStorage.getItem('login')
    console.error('[SECURITY] Usuário:', usuarioLogin, 'Timestamp:', new Date().toISOString())
  }

  if (!loadingPerms) {
    loadingPerms = store.dispatch('menu/GERAR_LISTA')
      .catch((err) => {
        console.error('[menu] Erro ao carregar permissões:', err)
        return []
      })
      .finally(() => { loadingPerms = null })
  }

  await loadingPerms
  const newPerms = store.getters['menu/userPermissions'] || []
  setPermissionsCache(newPerms)

  return newPerms
}


router.beforeEach(async (to, from, next) => {
  // debug: trace navigation attempts

  const token = localStorage.getItem('token')

  // Sem token: apenas públicas
  if (!token) {
    return PUBLIC_ROUTES.has(to.path) ? next() : next('/pages/login')
  }

  // Com token: garante permissões carregadas + cache
  const userPermissions = await ensurePermissions()

  // Home dinâmica ('/')
  if (to.path === '/') {
    const home = computeHome(userPermissions)
    if (from.path !== home) {
      return next({ path: home, replace: true })
    }
    return next()
  }

  // ===== [2] “Última rota” pós-login (preferir se for permitida) =====
  if (to.path === '/pages/login') {
    const ultima = localStorage.getItem('ultimaRota')
    if (ultima && !PUBLIC_ROUTES.has(ultima) && hasPermissionCached(ultima)) {
      return next({ path: ultima, replace: true })
    }
    const home = computeHome(userPermissions)
    return next({ path: home, replace: true })
  }

  // Públicas passam
  if (PUBLIC_ROUTES.has(to.path)) {
    return next()
  }

  // Checagem de permissão usando cache
  if (!hasPermissionCached(to.path)) {
    return next('/pages/404')
  }

  return next()
})

// Global router error handler to catch chunk load / dynamic import failures
router.onError(err => {
  try {
    console.error('[router] onError', err && err.message ? err.message : err)
    // If it's a chunk loading failure, inform the developer quickly
    if (err && /loading chunk|Loading chunk/i.test(err.message || '')) {
      console.error('[router] ChunkLoadError detected. Check network/compile and the console for 404s on chunk files.')
    }
  } catch (e) {
    console.error('[router] onError handler failed', e)
  }
})

router.afterEach((to, from) => {
  // guarda “última rota” apenas se não for pública
  if (from && from.path && !PUBLIC_ROUTES.has(from.path)) {
    localStorage.setItem('ultimaRota', from.path)
  }
})

/** =========================
 *  [4] Recarregar permissões sob demanda
 *  ========================= */
export async function refreshPermissions() {
  await store.dispatch('menu/GERAR_LISTA')
  const perms = store.getters['menu/userPermissions'] || []
  setPermissionsCache(perms)

  // Se a rota atual perdeu permissão, manda para home dinâmica
  const current = router.currentRoute && router.currentRoute.path
  if (current && !PUBLIC_ROUTES.has(current) && !hasPermissionCached(current)) {
    const home = computeHome(perms)
    router.replace(home)
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js